import * as React from 'react';
import style from './UserAddresses.module.scss';
import UserAddresses from 'common/components/UserAddresses/UserAddresses';
import { useTranslation } from 'react-i18next';
import { Button, Card } from 'antd';
import SingleUserAddressesDialogsView from './SingleUserAddressesDialogsView';
import Flex from 'common/components/Flex';
import Link from 'web/components/Link';
import EditIcon from 'common/icons/edit_v2.svg';
import { observer } from 'mobx-react';
import { PartyDto } from 'model/Api/Parties/Model/PartyDto';
import Add from 'common/icons/plus.svg';

interface AllUsersAddressDropdownProps {
    model: UserAddresses | undefined;
    withCreateAddress?: boolean;
    userId?: number;
    disabled?: boolean;
}

const AllUsersAddressDropdown: React.FC<AllUsersAddressDropdownProps> = observer(
    ({ model, disabled, withCreateAddress = true, userId }) => {
        const { t } = useTranslation(['userAddresses', 'common']);

        if (!model || !model.isSelectable) return null;

        const data: PartyDto[] = [
            ...model.sortedParties['private'],
            ...model.sortedParties['company']
        ];

        return (
            <div className={style.cardsContainer}>
                {data.map((party) => {
                    const isSelected = model.selectedParty === party.id;

                    return (
                        <Card
                            key={party.id}
                            hoverable={!disabled}
                            onClick={() =>
                                !disabled && model.onSelectAddress(party.id)
                            }
                            className={`${style.card} ${isSelected ? style.selected : ''
                                }`}>
                            <Flex
                                justifyContent='space-between'
                                alignItems='center'
                                flexDirection='column'
                                customClass={style.cardContent}>
                                <Flex
                                    justifyContent='space-between'
                                    alignItems='center'
                                    customClass={style.topRow}>
                                    <span className={style.dropdownText}>
                                        {!!party.name && `${party.name}, `}
                                    </span>
                                    {!disabled && (
                                        <div className={style.actions}>
                                            <>
                                                <img
                                                    src={EditIcon}
                                                    alt='edit'
                                                    className={style.dropdownIcon}
                                                />
                                                <Link
                                                    onClick={() =>
                                                        model.onEdit(party, userId)
                                                    }
                                                    style={style.dropdownLink}>
                                                    {t('common:edit')}
                                                </Link>
                                            </>
                                        </div>
                                    )}

                                </Flex>
                                <ul className={style.addressText}>
                                    {!!party.careOf && (
                                        <li>{`${party.orgNo ? 'att. ' : 'c/o '
                                            } ${party.careOf}`}</li>
                                    )}
                                    {!!party.address.line && (
                                        <li>{party.address.line}</li>
                                    )}
                                    <li>{`${party.address.postalCode} ${party.address.city}`}</li>
                                </ul>
                            </Flex>
                        </Card>
                    );
                })}

                {withCreateAddress && !disabled && (
                    <Button
                        disabled={disabled}
                        className={style.addButton}
                        type='text'
                        size='small'
                        onClick={() => model.onCreateAddress()}>
                        <img src={Add} alt='add' />
                        {t('userAddresses:addAddress')}
                    </Button>
                )}

                <SingleUserAddressesDialogsView model={model} />
            </div>
        );
    }
);

export default AllUsersAddressDropdown;
